import { DennemeyerRenewalsProvider } from "../dennemeyer/new_way/Renewals";
import { PRRenewalsProvider } from "../patent_renewal/Renewals";
import { DummyRenewalsProvider } from "../dummy/Renewals";
import { RenewalState } from "./renewal_types";
import { useSettings } from "./Settings";

export default function RenewalsProvider(props: { start?: string; end?: string; states: RenewalState[]; children: React.ReactNode }) {
  const { implementation } = useSettings()
  switch (implementation) {
    case 'dennemeyer':
      return <DennemeyerRenewalsProvider {...props} />
    case 'patent-renewal':
      return <PRRenewalsProvider {...props} />
    case 'dummy':
      return <DummyRenewalsProvider {...props} />
    default:
      return null
  }
}